// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__AS3eL","profileImg":"Profile_profileImg__SW9AE","dropMenu":"Profile_dropMenu__HFzSM","logOutMenu":"Profile_logOutMenu__1zplg"};